import React from "react";
import querystring from "querystring";
import { connect } from "react-redux";
import { logIn } from "auth/authActions";

const mapStateToProps = state => ({
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  onUnauthorized: ({ pathname, search }) => {
    const searchParams = querystring.parse(search.substring(1));

    console.log(
      "Unauthorized, dispatching LOG_IN, redirectPath: %O, oAuthCode: %O",
      pathname,
      searchParams.code,
    );

    dispatch(logIn(pathname, searchParams.code));
  },
});

const requiresAuthentication = Component => {
  const wrappedComponent = class extends React.Component {
    render() {
      this.checkAuth(this.props);
      return <Component {...this.props} />;
    }

    checkAuth(nextProps) {
      if (!nextProps.user.token) {
        nextProps.onUnauthorized(nextProps.location);
      }
    }
  };

  return connect(mapStateToProps, mapDispatchToProps)(wrappedComponent);
};

export default requiresAuthentication;
